import React from "react";
import Project from "./index";

export function ProjectFenced() {
  return <Project status="Cloturé" />;
}